/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Video_Broadcast_HintInputs */

const th_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`เลือกกล้องเพื่อถ่ายทอดเกม เบราว์เซอร์จะขออนุญาตจากคุณ`)
};

const en_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choose a camera to broadcast the game. Your browser will ask for permission.`)
};

const ja_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`試合を配信するカメラを選んでください。ブラウザが許可を求めます。`)
};

const zh_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`选择一个摄像头来直播比赛。浏览器会请求权限。`)
};

const es_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Elige una cámara para retransmitir el partido. Tu navegador pedirá permiso.`)
};

const pt_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Escolha uma câmera para transmitir o jogo. Seu navegador vai pedir permissão.`)
};

const id_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih kamera untuk menyiarkan pertandingan. Peramban Anda akan meminta izin.`)
};

const fr_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Choisissez une caméra pour diffuser le match. Votre navigateur demandera l’autorisation.`)
};

const tl_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pumili ng camera para isahimpapawid ang laro. Hihingi ng pahintulot ang browser mo.`)
};

const vi_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chọn một máy ảnh để phát trận. Trình duyệt sẽ hỏi quyền.`)
};

const ko_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`경기를 중계할 카메라를 고르세요. 브라우저가 권한을 요청합니다.`)
};

const de_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wähle eine Kamera, um das Spiel zu übertragen. Dein Browser fragt nach der Berechtigung.`)
};

const ru_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Выберите камеру, чтобы транслировать матч. Браузер запросит разрешение.`)
};

const tr_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Maçı yayınlamak için bir kamera seçin. Tarayıcınız izin isteyecek.`)
};

const it_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Scegli una fotocamera per trasmettere la partita. Il browser chiederà il permesso.`)
};

const pl_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Wybierz kamerę, aby transmitować mecz. Przeglądarka poprosi o zgodę.`)
};

const uk_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Оберіть камеру, щоб транслювати матч. Браузер запитає дозвіл.`)
};

const hi_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`मैच प्रसारित करने के लिए कैमरा चुनें। आपका ब्राउज़र अनुमति माँगेगा।`)
};

const ar_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`اختر كاميرا لبثّ المباراة. سيطلب متصفحك الإذن.`)
};

const ms_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Pilih kamera untuk menyiarkan perlawanan. Pelayar anda akan meminta kebenaran.`)
};

const bn_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`খেলা সম্প্রচার করতে একটি ক্যামেরা বেছে নিন। ব্রাউজার অনুমতি চাইবে।`)
};

const zh_tw2_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇一台相機來轉播比賽。你的瀏覽器會要求權限。`)
};

const zh_hk2_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`選擇一台相機來轉播比賽。你的瀏覽器會要求權限。`)
};

const ur_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`میچ نشر کرنے کے لیے کیمرا چنیں۔ آپ کا براؤزر اجازت مانگے گا۔`)
};

const fa_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`برای پخش بازی دوربینی برگزینید. مرورگرتان اجازه می‌خواهد.`)
};

const sw_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Chagua kamera ili kurusha mchezo. Kivinjari chako kitaomba ruhusa.`)
};

const nl_video_broadcast_hint = /** @type {(inputs: Video_Broadcast_HintInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Kies een camera om de wedstrijd uit te zenden. Je browser vraagt om toestemming.`)
};

/**
* | output |
* | --- |
* | "Choose a camera to broadcast the game. Your browser will ask for permission." |
*
* @param {Video_Broadcast_HintInputs} inputs
* @param {{ locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }} options
* @returns {LocalizedString}
*/
export const video_broadcast_hint = /** @type {((inputs?: Video_Broadcast_HintInputs, options?: { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Video_Broadcast_HintInputs, { locale?: "th" | "en" | "ja" | "zh" | "es" | "pt" | "id" | "fr" | "tl" | "vi" | "ko" | "de" | "ru" | "tr" | "it" | "pl" | "uk" | "hi" | "ar" | "ms" | "bn" | "zh-TW" | "zh-HK" | "ur" | "fa" | "sw" | "nl" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "th") return th_video_broadcast_hint(inputs)
	if (locale === "ja") return ja_video_broadcast_hint(inputs)
	if (locale === "zh") return zh_video_broadcast_hint(inputs)
	if (locale === "es") return es_video_broadcast_hint(inputs)
	if (locale === "pt") return pt_video_broadcast_hint(inputs)
	if (locale === "id") return id_video_broadcast_hint(inputs)
	if (locale === "fr") return fr_video_broadcast_hint(inputs)
	if (locale === "tl") return tl_video_broadcast_hint(inputs)
	if (locale === "vi") return vi_video_broadcast_hint(inputs)
	if (locale === "ko") return ko_video_broadcast_hint(inputs)
	if (locale === "de") return de_video_broadcast_hint(inputs)
	if (locale === "ru") return ru_video_broadcast_hint(inputs)
	if (locale === "tr") return tr_video_broadcast_hint(inputs)
	if (locale === "it") return it_video_broadcast_hint(inputs)
	if (locale === "pl") return pl_video_broadcast_hint(inputs)
	if (locale === "uk") return uk_video_broadcast_hint(inputs)
	if (locale === "hi") return hi_video_broadcast_hint(inputs)
	if (locale === "ar") return ar_video_broadcast_hint(inputs)
	if (locale === "ms") return ms_video_broadcast_hint(inputs)
	if (locale === "bn") return bn_video_broadcast_hint(inputs)
	if (locale === "zh-TW") return zh_tw2_video_broadcast_hint(inputs)
	if (locale === "zh-HK") return zh_hk2_video_broadcast_hint(inputs)
	if (locale === "ur") return ur_video_broadcast_hint(inputs)
	if (locale === "fa") return fa_video_broadcast_hint(inputs)
	if (locale === "sw") return sw_video_broadcast_hint(inputs)
	if (locale === "nl") return nl_video_broadcast_hint(inputs)
	return en_video_broadcast_hint(inputs)
});